import Button from 'components/Button';
import { IntrinsicSizeImg } from 'components/Img';
import RichText from 'components/RichText';
import Text from 'components/Text';
import type { FieldKey } from 'hooks';
import type { Product } from 'models/product';
import type { TemplateString } from 'types';
import { getBrandLogoImage } from 'utils/business-logic';
import { formatTemplate } from 'utils/format';

interface Props {
	className?: string;
	product: Product;
	visitBrandPageButtonText: FieldKey | TemplateString;
}

export default function ProductDetailsBrandInfo({
	className,
	product,
	visitBrandPageButtonText,
}: Props) {
	const { brand } = product;
	const brandLogoImage = getBrandLogoImage(product);

	if (!brand) {
		return null;
	}

	return (
		<div className={className}>
			<div className="mb-6">
				{brandLogoImage && (
					<IntrinsicSizeImg
						asset={brandLogoImage}
						className="mb-6 max-h-16 w-auto max-w-40"
					/>
				)}
				<Text as="h3" styleAs="h4" className="mb-2">
					{brand.longTitle}
				</Text>
				<RichText html={brand.descriptionFormatted} />
			</div>
			{brand.relativeUrl && (
				<Button href={brand.relativeUrl} variant="branded">
					{formatTemplate(visitBrandPageButtonText, {
						brand: product?.brand?.title,
					})}
				</Button>
			)}
		</div>
	);
}
ProductDetailsBrandInfo.displayName = 'ProductDetailsBrandInfo';
